var SCM = SCM || {};

(function (ns, $) {
    var sigma = $('.sigma').length;
    var sigmaGetAccessHtml =
        '<span class="get-access js-get-access-label at-get-access">Get access<img class="get-access-icon" src="/UI/app/svg/chevron-right-white.svg" alt="Arrow" aria-hidden="true"></span>';

    ns.setAccessIcons = function (accessIcons) {
        accessIcons = accessIcons || SCM.AccessIcons;

        var currentResourceList = $('[data-resource-id-access]');
        if (currentResourceList.length && accessIcons) {
            currentResourceList.each(function () {
                var $this = $(this);
                var resourceId = $this.data('resourceIdAccess');

                var accessIcon = SCM.SiteJS.getAccessIcon(resourceId, accessIcons);
                if (accessIcon) {
                    updateIconPlaceholders($this, accessIcon);
                }
            });

            if ($('.pg_book').length > 0) {
                setElementVisibilityBasedOnAccess();
            }
        }

        if ($('.js-nbnj-left-rail').length > 0) {
            setNBNJElementVisibilityBasedOnAccess();
        }
    };

    function updateIconPlaceholders($pageList, accessIcon) {
        var $placeholder = $pageList.find('.js-access-icon-placeholder');
        if (sigma && !$placeholder.length) {
            $placeholder = $pageList.find('.js-sigma-access-placeholder');
        }
        if ($placeholder.length) {
            // replace icon css class with either icons or get access button
            removeAllAccessIconClasses($placeholder);
            addAvailabilityClass(accessIcon.icon, $placeholder);
            $placeholder.attr('title', accessIcon.title);
        }
    }

    var getAccessIconClasses = ['icon-availability_restricted', 'icon-availability_cart'];
    function addAvailabilityClass(availabilityIconClass, $placeholder) {
        var $itemLink = $placeholder.prev();
        if (sigma && $.inArray(availabilityIconClass, getAccessIconClasses) !== -1) {
            $placeholder.remove();
            // have to wrap in span to include spacing between text and get access button within link
            // can't do it on get access button because if it wraps to new line, spacing is at the 
            // beginning of the new line.
            // If you include span when there's not a get access button, there's an extra space
            // between icon and title that gets underlined on hover.
            // not including get access html in view, because then it would also get wrapped in the 
            // access-title span, which we don't want.
            $itemLink.wrapInner('<span class="access-title"></span>');
            $itemLink.append(sigmaGetAccessHtml);
        } else {
            $placeholder.removeClass(availabilityIconClass).addClass(availabilityIconClass);
        }
    }

    function removeAllAccessIconClasses($accessIcon) {
        $accessIcon.removeClass(function (index, currentClass) {
            return (currentClass.match(/icon-availability_.+/g) || []).join(' ');
        });
    }

    // NBNJ specific, based on the function setElementVisibilityBasedOnAccess()
    function setNBNJElementVisibilityBasedOnAccess() {
        // if any reference articles are restricted, display the 'Get access' jumplink
        if ($('.js-get-access-solr-item-result').length > 0) { 
            $('.js-get-access-wrapper').removeClass('hidden');
        }
    }

    function setElementVisibilityBasedOnAccess() {
        let bookBottomSectionExists = $('.book-bottom-section').length > 0;

        if ($('.js-get-access-label').length > 0) { // if any chapters are restricted, display the 'Get access' jumplink
            $('.js-get-access-wrapper').removeClass('hidden');
            if (bookBottomSectionExists) {
                $('.book-bottom-section').addClass('book-bottom-section_remove-padding');
            }
        } else {                                    // Otherwise, hide the sign-in and purchase info
            $('.js-login-purchase-wrap').addClass('hidden');
            if (bookBottomSectionExists) {
                $('.book-bottom-section').removeClass('book-bottom-section_remove-padding');
            }            
        }
    }

    ns.getAccessIcon = function (resourceId, accessIcons) {
        accessIcons = accessIcons || SCM.AccessIcons;

        var accessIcon;
        accessIcons.map(function (x) { if (x.id === resourceId) { accessIcon = x; return false; } });
        return accessIcon;
    };

})(SCM.SiteJS = SCM.SiteJS || {}, jQuery);
